import clsx from "clsx";
import styles from "./PaginationButton.module.scss";

interface PaginationButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
}

export default function PaginationButton({
  onClick,
  children,
  disabled,
}: PaginationButtonProps) {
  return (
    <button
      type="button"
      className={clsx(styles.paginationButton, {
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
